import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 26.2 26.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.2 26.2\" id=\"more\"><g fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\"><path d=\"M13.1 0v26.2M26.2 13.1H0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol